import script from "./ColorThemeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorThemeButton.vue?vue&type=script&setup=true&lang=js"

import "./ColorThemeButton.vue?vue&type=style&index=0&id=5ca4168b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca4168b"]])

export default __exports__